import React from "react";

import './theme-simbud.css'
const ThemeSimbud = () => <></>;

export default ThemeSimbud;